import { extractApiErrorMessage } from "./apiError";

const STATUS_MESSAGES = {
  401: "tu sesión expiró, volvé a iniciar sesión",
  403: "no tenés permiso para hacerlo",
  409: "otro usuario lo modificó al mismo tiempo, recargá la página",
  429: "demasiados intentos seguidos, esperá un momento",
};

export function describeRequestError(error, action, { notFound = "ya no existe" } = {}) {
  if (!error?.response) return `${action}: no hay conexión con el servidor.`;

  const status = Number(error.response.status);
  if (status >= 500) return `${action}: el servidor devolvió un error (${status}).`;

  const detail = extractApiErrorMessage(error);
  if (detail) return `${action}: ${detail.trim().replace(/\.$/, "")}.`;

  if (status === 404) return `${action}: ${notFound}.`;
  if (STATUS_MESSAGES[status]) return `${action}: ${STATUS_MESSAGES[status]}.`;

  return `${action}.`;
}
